module.exports = "/images/GalaxCommerce.png?2acfe090bf33ac102eac85156824f717";